import {refreshTeamCreditsInStore} from '@Components/team-credits/team-credits-library';
import {closeStockMediaPopup} from '@Components/poster-editor/components/poster-add-item-bar/components/stock-media-dropdown/stock-media-popup-controller';
import {openCheckoutForCreditPackPurchase} from '@Modals/checkout-modal/checkout-modal.library';
import {noop} from '@Utils/general.util';

export const buyCreditPack = (onPurchased: () => void = noop): void => {
  openCheckoutForCreditPackPurchase({
    headingText: '',
    modalTitle: window.i18next.t('pmwjs_select_a_credit_pack'),
    onSuccess: (): void => {
      void refreshTeamCreditsInStore();
      onPurchased();
    },
    onOpen: closeStockMediaPopup,
  });
};
